const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M39.9953%200H0V20.4004H39.9953V0Z'%20fill='%23E9041E'/%3e%3cpath%20d='M39.9953%2020H0V40H39.9953V20Z'%20fill='black'/%3e%3cpath%20d='M33.01%2018.7847H6.99023V21.2199H33.01V18.7847Z'%20fill='white'/%3e%3c/svg%3e";
export {
  e as default
};
